<template>
  <div>
    <top-menu-card
      mark="A"
      icon="mdi-feature-search-outline"
      :color="color">
      <template #title>
        A. 整合性の確認表作成準備入力
      </template>
      <template #subtitle>
        基本情報と、部屋番号・部屋名等の入力します。
      </template>
      <template #actions>
        <v-spacer />
        <v-btn
          v-if="hasApprovalAuthority"
          color="black"
          outlined
          @click.prevent="onCreateClicked">
          新規作成
          <v-icon dense>mdi-arrow-right</v-icon>
        </v-btn>
        <v-btn
          class="mt-2"
          :color="color"
          outlined
          @click.prevent="onInputClicked">
          入力する
          <v-icon dense>mdi-arrow-right</v-icon>
        </v-btn>
      </template>
    </top-menu-card>
    <unsaved-session-confirm
      v-if="confirmDialog"
      v-model="confirmDialog"
      session-name="confirmation"
      route-name-new="confirmationIndex"
      route-name-continue="confirmationEditStep1"
      @cancel="confirmDialog=false" />
  </div>
</template>

<script>
import TopMenuCard from './TopMenuCard'
import UnsavedSessionConfirm from '../UnsavedSessionConfirm'

export default {
  name: 'TopConfirmationMenu',
  components: { UnsavedSessionConfirm, TopMenuCard },
  props: {
    color: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      confirmDialog: false,
      nextRouteParams: {},
      loadSessionRouteParams: {},
    }
  },
  computed: {
    hasApprovalAuthority() {
      return !!this.$store.state.auth.has_approval_authority
    },
  },
  methods: {
    // A.整合性確認表新規作成
    onCreateClicked() {
      this.$router.push({ name: 'confirmationNew' })
    },
    // A.整合性確認表一覧
    onInputClicked() {
      this.$router.push({ name: 'confirmationIndex' })
    },
  },
}
</script>
